// @flow
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import LinkIcon from '@mui/icons-material/Link';
import QrCode2Icon from '@mui/icons-material/QrCode2';

import { GlobalState } from './GlobalContext';

import DocInfoEditDialog from './DocInfoEditDialog';
import DocLinkDialog from './DocLinkDialog';
import QRCodeDialog from './QRCodeDialog';
import DocInfoFormContent from './DocInfoFormContent';


export default function DocInfoTab(props) {
  const {
    sysID,
    docDetail,
    docTypes,
    folders,
    afterDocDetailUpdate,
    // disableEdit,
    notInDialog,
    compactMode,
    readonly,
    alwayEdit,
  } = props;

  const [gState] = React.useContext(GlobalState);

  const [openEditDocInfo, setOpenEditDocInfo] = useState(false);
  const [openDocLinkDialog, setOpenDocLinkDialog] = useState(false);
  const [docLink, setDocLink] = useState('');
  const [openQRCodeDialog, setOpenQRCodeDialog] = useState(false);

  const handleAfterDocDetailUpdate = () => {
    setOpenEditDocInfo(false);
    afterDocDetailUpdate && afterDocDetailUpdate();
  };

  const handleDocLinkClick = () => {
    const vParam = encodeURIComponent(
      Buffer.from(`sysID=${sysID}&docID=${docDetail.DocID}`).toString('base64')
    );
    const vUrl = `${window.location.origin}/?d=${vParam}`;

    setDocLink(vUrl);
    setOpenDocLinkDialog(true);
  };

  const handleQRDialogClick = () => {
    setOpenQRCodeDialog(true);
  };

  const heightOps = !notInDialog ? { height: "70vh" } : {};

  return (
    <Box sx={{ width: 1, maxWidth: 1, minWidth: 0 }}>
      {!notInDialog && (
        <Box sx={{ py: 1, px: 1 }}>
          {!alwayEdit && (
            <Button
              disabled={readonly}
              startIcon={<EditIcon />}
              onClick={() => setOpenEditDocInfo(true)}
            >
              Edit
            </Button>
          )}

          <DocInfoEditDialog
            open={openEditDocInfo}
            onClose={() => setOpenEditDocInfo(false)}
            sysID={sysID}
            data={docDetail}
            docTypes={docTypes}
            folders={folders}
            afterDocDetailUpdate={handleAfterDocDetailUpdate}
          />

          <Button startIcon={<LinkIcon />} onClick={handleDocLinkClick}>
            Document Link
          </Button>

          <DocLinkDialog
            open={openDocLinkDialog}
            onClose={() => setOpenDocLinkDialog(false)}
            docLink={docLink}
          />

          <Button startIcon={<QrCode2Icon />} onClick={handleQRDialogClick}>
            QR Code
          </Button>

          <QRCodeDialog
            open={openQRCodeDialog}
            onClose={() => setOpenQRCodeDialog(false)}
            qrValue={docDetail?.DocID.toString()}
          />
        </Box>
      )}

      <Box sx={{ px: 1, pb: 1 }}>
        <DocInfoFormContent
          sysID={sysID}
          sessionID={gState.sessionID}
          docDetail={docDetail}
          docTypes={docTypes}
          folders={folders}
          readonly={readonly}
          alwayEdit={alwayEdit}
          compactMode={compactMode}
          notInDialog={notInDialog}
          afterDocDetailUpdate={afterDocDetailUpdate}
        />
      </Box>
    </Box>
  );
}

DocInfoTab.propTypes = {
  sysID: PropTypes.string,
  docDetail: PropTypes.object,
  afterDocDetailUpdate: PropTypes.func,
  docTypes: PropTypes.array,
  folders: PropTypes.array,
  // disableEdit: PropTypes.bool,
  notInDialog: PropTypes.bool,
  compactMode: PropTypes.bool,
  readonly: PropTypes.bool,
  alwayEdit: PropTypes.bool,
};

DocInfoTab.defaultProps = {
  docTypes: [],
  folders: [],
  // disableEdit: false,
  notInDialog: false,
  compactMode: false,
  readonly: true,
  alwayEdit: false,
};